import { ICommonApi } from './environment.type';

/** Эндпоинты проекта */
export const COMMON_APIS: ICommonApi = {
  graphql: '/gateway/hasura',
  graphql_ws: '/gws/hasura-ws',
  storage: '/gateway/storage',
  exporter: '/gateway/exporter',
  importer: '/gateway/importer',
  mail: '/gateway/mailing',
  docProcessing: '/gateway/logic',
};

/** Переменные окружения, которые будут установлены после загрузки файла конфигурации */
export const LOADED_FROM_CONFIG_ENVS = {
  keycloak: {
    url: '',
    realm: '',
    clientId: '',
  },
  s3Bucket: '',
  sentryDsn: '',
};
